import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AddAsteriskDirective } from './directive/add-asterisk.directive';
import { AvatarComponent } from './avatar/avatar.component';
import { ButtonComponent } from './button/button.component';
import { CodeInputComponent } from './form/code-input/code-input.component';
import { FieldErrorComponent } from './form/field-error/field-error.component';
import { PrimeNgModule } from './modules/prime-ng.module';
import { TrimOnBlurDirective } from './directive/trim-on-blur.directive';

const SHARED_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PrimeNgModule,
];

const SHARED_DECLARATIONS = [
    AddAsteriskDirective,
    AvatarComponent,
    ButtonComponent,
    CodeInputComponent,
    FieldErrorComponent,
    TrimOnBlurDirective,
];

@NgModule({
    declarations: [...SHARED_DECLARATIONS],
    imports: [...SHARED_MODULES],
    exports: [...SHARED_MODULES, ...SHARED_DECLARATIONS],
})
export class SharedModule {}
